<template>
	<div class="c-image-header" :style="`background-image: url('${src}')`">
		<div class="o-width-limiter">
			<div
				class="c-image-header__overlayimage-wrapper"
				v-if="overlayimage"
			>
				<div class="c-image-header__overlayimage">
					<img
						:src="overlayimage"
						class="c-image-header__roof"
						alt=""
						aria-hidden="true"
					/>
				</div>
			</div>
			<div class="c-image-header__content-wrapper" v-if="hasContent">
				<div class="c-image-header__content">
					<img
						src="/gui/images/roof-white-total.svg"
						class="c-image-header__roof"
						alt=""
						aria-hidden="true"
					/>
					<p class="c-image-header__text">
						{{ text }}
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "VImageHeader",
	props: {
		text: {
			type: String
		},
		src: {
			type: String
		},
		overlayimage: {
			type: String
		}
	},
	computed: {
		hasContent(){
			if(!this.text){
				return false;
			}
			
			return this.text.trim().length > 0;
		}
	}
};
</script>
